import { render } from "./InternationalVolunteer.vue?vue&type=template&id=1084e354&scoped=true"
import script from "./InternationalVolunteer.vue?vue&type=script&lang=js"
export * from "./InternationalVolunteer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1084e354"

export default script